import { FAILURE, REQUEST, SUCCESS } from 'app/shared/util/action-type.util';
import { ACTION_TYPES } from './action';
import { FinanceState, initialState } from './state';

export default (state: FinanceState = initialState, action): FinanceState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_HMAK):
      return {
        ...state,
      };

    case SUCCESS(ACTION_TYPES.GET_HMAK): {
      return {
        ...state,
        PaymentResponse: action.payload.data,
      };
    }

    case FAILURE(ACTION_TYPES.GET_HMAK): {
      return {
        ...initialState,
      };
    }

    case ACTION_TYPES.SET_ERROR: {
      return {
        ...state,
        error: action.payload.error,
      };
    }

    case ACTION_TYPES.RESET_ERROR: {
      return {
        ...state,
        error: undefined,
      };
    }

    default:
      return state;
  }
};
